import { RoleEnum } from "../enums";

const STORAGE_KEY = "cp_teacher_schedule_highlight_seen";
export const TEACHER_SCHEDULE_HIGHLIGHT_EVENT =
  "cp-teacher-schedule-highlight-seen";

export const hasSeenTeacherScheduleHighlight = (): boolean =>
  localStorage.getItem(STORAGE_KEY) === "true";

export const shouldShowTeacherScheduleHighlight = (
  roleKey?: string,
): boolean =>
  roleKey === RoleEnum.TEACHER_ADMIN && !hasSeenTeacherScheduleHighlight();

export const markTeacherScheduleHighlightSeen = (): void => {
  localStorage.setItem(STORAGE_KEY, "true");
  window.dispatchEvent(new Event(TEACHER_SCHEDULE_HIGHLIGHT_EVENT));
};
